import { Controller } from '@hotwired/stimulus';
import { CalendarLayerPreferences } from '../lib/calendar_layer_preferences.mjs';

// The URL owns the current render. localStorage remembers only layer slugs and is consulted
// solely when no explicit layer selection is present; the server filters every restored slug.
export default class extends Controller {
  static values = {
    key: String,
    explicit: Boolean,
    active: Array,
    eligible: Array
  };

  connect() {
    const preference = new CalendarLayerPreferences({ storage: window.localStorage, key: this.keyValue });
    if (this.explicitValue) {
      preference.write(this.activeValue);
      return;
    }

    const restored = preference.restoredUrl(window.location.href, this.eligibleValue);
    if (restored) this.restore(restored);
  }

  restore(url) {
    const frame = this.element.closest('turbo-frame');
    if (!frame) {
      window.Turbo.visit(url, { action: 'replace' });
      return;
    }

    // The first render may need to add remembered layers to the URL. Loading them through the
    // same Frame avoids a full-page flash; `replace` keeps this automatic normalization from
    // adding a synthetic Back entry. Passing the Frame through Turbo.visit is load-bearing:
    // assigning `frame.src` alone fetches the fragment but does not promote its URL to history.
    window.Turbo.visit(url, { action: 'replace', frame: frame.id });
  }
}
